import getDefaultImageUrls from './getDefaultImageUrls';
import getSourceSet from './getSourceSet';
import { ResponsiveImageConfiguration } from './graphql/api/graphql';

export const getProxiedImagesForConfigurations = (
  imageConfigurations: ResponsiveImageConfiguration[],
  originalImageUrls: (string | null | undefined)[],
) => {
  const defaultImageUrls = getDefaultImageUrls(imageConfigurations);

  const imageUrls = (originalImageUrls.every(
    (url) => typeof url === 'string',
  ) ? originalImageUrls : defaultImageUrls) as string[];

  const sourceSet = getSourceSet(imageConfigurations, imageUrls);

  return { imageUrls, srcSet: sourceSet };
};

const getProxiedImages = (
  variables: {
    imageConfigurations: ResponsiveImageConfiguration[];
  },
  originalImageUrls: (string | null | undefined)[],
) => {
  const { imageConfigurations } = variables;
  return getProxiedImagesForConfigurations(
    imageConfigurations,
    originalImageUrls,
  );
};

export default getProxiedImages;
